import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var rangingTool;
var map;
var htmlContent;
var mouseTool;
var placeSearch;
import { queryFileList, queryAreaInfo } from '@/api/api';
import mapImg from '@/assets/others/map1.png';
export default {
  props: {
    pipePositionLists: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    markerPhotoUrl: {
      default: 'site_pipe_inspection_record_point',
      type: String
    },
    // 地图高度
    height: {
      default: '',
      type: String
    },
    width: {
      default: '100%',
      type: String
    },
    // 地图选择的类型 0:选取点 1:选取线
    selectType: {
      type: Number,
      default: 0
    },
    // 搜索框的显示状态
    searchState: {
      type: String,
      default: '1'
    },
    // 测距侧面积框的状态
    showMeasure: {
      type: String,
      default: '1'
    },
    is3D: {
      type: String,
      default: '1'
    }
  },
  watch: {
    markerPosition: function markerPosition(val) {
      this.selectedMarker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: new AMap.LngLat(val[0], val[1])
      });
      map.add(this.selectedMarker);
    }
  },
  data: function data() {
    return {
      url: {
        tree: '/site/pipe/inspection/record/point/tree',
        imageUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view/'
      },
      photoItems: [],
      current: 0,
      showMap: false,
      title: '',
      pipeMarkerPositionList: [],
      areaName: '雅安市',
      polyLineArr: [],
      polyEditorArr: [],
      tabList: [{
        'id': 0,
        'name': '画线'
      }, {
        'id': 1,
        'name': '修改'
      }, {
        'id': 2,
        'name': '完成'
      }, {
        'id': 3,
        'name': '清除'
      }],
      selectedId: 4,
      pipePositionList: [],
      //管线坐标数组
      lastLabel: [],
      //之前的label的数组
      markerList: [],
      //站点巡检点坐标
      labelPositions: '',
      markerPosition: '',
      searchValue: '',
      state: false,
      location: '',
      adcode: '',
      adname: '',
      showContens: false,
      showTab: false,
      value: '',
      showClose: false,
      showState: false,
      mesureState: false,
      arr: [],
      map: null,
      timer: ''
    };
  },
  mounted: function mounted() {// this.$nextTick(() => {
    // 	setTimeout(()=>{
    // 		this.initMap()
    //     this.drawBounds(1)
    // 	},1000)
    // })
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    map && map.destroy();
  },
  methods: {
    onToLast: function onToLast() {
      if (this.photoItems.length == 0) {
        fetch.toast('无法切换上一张');
        return;
      }

      if (this.current == 0) {
        this.current = this.photoItems.length - 1;
      } else {
        this.current--;
      }
    },
    onToNext: function onToNext() {
      if (this.photoItems.length == 0) {
        fetch.toast('无法切换上一张');
        return;
      }

      if (this.current >= this.photoItems.length - 1) {
        this.current = 0;
      } else {
        this.current++;
      }
    },
    onTotab: function onTotab(id) {
      var _this = this;

      if (this.selectedId == id) this.selectedId = 4;else this.selectedId = id;

      switch (id) {
        // 画线
        case 0:
          mouseTool.polyline({
            strokeWeight: 5
          });
          mouseTool.on('draw', function (e) {
            var arr = e.obj.getPath();
            var b = [];
            arr.forEach(function (item, index) {
              var a = [];
              a.push(item.getLng().toString());
              a.push(item.getLat().toString());
              b.push(a);
            });

            _this.pipePositionList.push(b);

            var polyLine = e.obj;
            var polyEditor = new AMap.PolyEditor(map, polyLine);

            _this.polyLineArr.push(polyLine);

            _this.polyEditorArr.push(polyEditor);

            _this.$emit('labelPosition', _this.pipePositionList);
          });
          break;
        // 修改

        case 1:
          mouseTool.close();
          this.polyEditorArr.forEach(function (item, index) {
            item.open();
            item.on('adjust', function (res) {
              var arr = res.target.getPath();
              var b = [];
              arr.forEach(function (item1, index1) {
                var a = [];
                a.push(item1.getLng());
                a.push(item1.getLat());
                b.push(a);
              });
              _this.pipePositionList[index] = b;

              _this.$emit('labelPosition', _this.pipePositionList);
            });
          });
          break;
        // 完成

        case 2:
          mouseTool.close();
          this.polyEditorArr.forEach(function (item) {
            item.close();
          }); // this.polyEditor.close()

          break;
        // 清除

        case 3:
          mouseTool.close();
          this.polyLineArr.forEach(function (item) {
            map.remove(item);
          });
          this.polyLineArr = [];
          this.polyEditorArr = [];
          this.pipePositionList = [];
          this.$emit('labelPosition', this.pipePositionList);
      }
    },
    getMaparea: function getMaparea(name, type) {
      var that = this;
      process.env.VUE_APP_TITLE == 'anyue' ? name = '安岳县' : ''; // let name2 = name

      if (that.polygon) {
        map.remove(that.polygon);
      }

      AMap.plugin(['AMap.DistrictSearch', 'AMap.Polygon', 'AMap.Polyline'], function () {
        new AMap.DistrictSearch({
          extensions: 'all',
          subdistrict: 0
        }).search(name, function (status, result) {
          // 外多边形坐标数组和内多边形坐标数组
          // map.setCenter(result.districtList[0].center)
          var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
          var holes = result.districtList[0].boundaries;
          var pathArray = [outer];
          pathArray.push.apply(pathArray, holes);
          that.polygon = new AMap.Polygon({
            map: map,
            pathL: pathArray,
            strokeColor: '#000',
            //城市边界颜色
            strokeWeight: 2,
            fillColor: '#6a6a6a',
            // 遮罩背景色黑色
            fillOpacity: 0.7,
            bubble: true
          });
          that.polygon.setPath(pathArray);

          if (name == '雅安市') {
            map.setZoom(9);
          } else if (name == '中国') {
            map.setZoom(5);
          } else if (name == '四川省') {
            map.setZoom(8);
          } else {
            map.setZoom(11);
          }

          that.polygon.setMap(map);

          switch (that.selectType) {
            case 0:
              that.selectMarker();
              break;

            case 1:
              that.selectLine();
              break;

            case 2:
              that.drawLine();
              break;
          }
        });
      });
    },
    // 搜索框点击回车
    submit: function submit() {
      console.log(this.state);

      if (this.state) {
        map.setZoom(14);
        map.setCenter(this.location);
      } else {
        console.log(this.adcode, this.searchValue);
        placeSearch.setCity(this.adcode);
        placeSearch.search(this.searchValue);
      }
    },
    setCenter: function setCenter(position) {
      console.log('map', map);
      console.log('position', position);
      map.setCenter(position);
    },
    // 清除地图上标注
    ontoClear: function ontoClear() {
      this.showClose = false;
      mouseTool.close(true);
    },
    // 关闭
    ontoClose: function ontoClose() {
      this.showClose = false;
      mouseTool.close();
    },
    // 距离测量
    ontoMesure: function ontoMesure() {
      this.showState = true;
      this.showClose = true;
      mouseTool.rule({
        startMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/start.png'
          })
        },
        endMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/end.png'
          }),
          offset: new AMap.Pixel(-9, -31)
        },
        midMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/mid.png'
          }),
          offset: new AMap.Pixel(-9, -31)
        },
        lineOptions: {
          //可缺省
          strokeStyle: 'solid',
          strokeColor: '#FF33FF',
          strokeOpacity: 1,
          strokeWeight: 2
        }
      });
    },
    // 区域面积测量
    ontoArea: function ontoArea() {
      this.showState = false;
      this.showClose = true;
      mouseTool.measureArea({
        strokeColor: '#80d8ff',
        fillColor: '#80d8ff',
        fillOpacity: 0.3 //同 Polygon 的 Option 设置

      });
    },
    // 工具栏弹出
    onShowright: function onShowright() {
      var _this2 = this;

      this.showTab = !this.showTab;
      setTimeout(function () {
        _this2.showContens = !_this2.showContens;
      }, 500);
    },
    drawBounds: function drawBounds(type) {
      var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
      areaRoot.forEach(function (item) {
        queryAreaInfo(item).then(function (res) {
          if (res.success) {
            if (res.result.mapCenter) {// map.setCenter(JSON.parse(res.result.mapCenter))
            }

            var features = [];

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
              var inline = features.map(function (area) {
                return area.map(function (info) {
                  return new AMap.LngLat(info[0], info[1], true);
                });
              });
              var pathArray = [outer];
              pathArray.push.apply(pathArray, inline);
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: type == 1 ? 'rgba(0,0,0)' : 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: type == 1 ? 0.5 : 0.3,
                zIndex: 99999999
              });
              polygon.setPath(pathArray);
              map.add(polygon); // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })
            }
          }
        });
      });
    },
    initMap: function initMap() {
      var _this3 = this;

      var that = this;
      map = new AMap.Map('container', {
        center: that.center,
        mapStyle: 'amap://styles/c50f29936c9c0aae3bb381dfef7289fe',
        // 极夜蓝
        pitch: 55,
        buildingAnimation: true,
        expandZoomRange: true,
        zooms: [3, 30] // viewMode: '3D'

      });

      if (that.is3D == '0') {
        map.setPitch(0);
      }

      map.setZoom(that.zoom);
      map.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.PolyEditor'], function () {
        var autoOptions = {
          // datatype: 'all',
          input: 'keyword',
          //使用联想输入的input的id
          zIndex: 10000000000000
        };
        var autocomplete = new AMap.Autocomplete(autoOptions);
        placeSearch = new AMap.PlaceSearch({
          map: map,
          pageSize: 1,
          extensions: 'all'
        });
        AMap.event.addListener(autocomplete, 'select', function (e) {
          //TODO 针对选中的poi实现自己的功能
          if (e.poi.location.lng != undefined) {
            map.setZoom(14); // map.setCenter(new AMap.LngLat(e.poi.location.lng, e.poi.location.lat))

            that.state = true;
            that.location = new AMap.LngLat(e.poi.location.lng, e.poi.location.lat);
          } else {
            that.state = false;
            that.adcode = e.poi.adcode;
            that.adname = e.poi.name;
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
          }
        });
      });
      map.plugin(['AMap.MapType', 'AMap.MouseTool', 'AMap.ControlBar'], function () {
        //地图类型切换
        var type = new AMap.MapType({
          defaultType: 1,
          //使用2D地图
          showRoad: true,
          showTraffic: true
        });
        mouseTool = new AMap.MouseTool(map);
        map.addControl(type);

        if (_this3.is3D == '1') {
          map.addControl(new AMap.ControlBar({
            position: {
              bottom: '-20%',
              right: '20px'
            }
          }));
        }
      });
      map.plugin(['AMap.RangingTool'], function () {
        rangingTool = new AMap.RangingTool(map);
        AMap.event.addListener(rangingTool, 'end', function (e) {
          rangingTool.turnOff();
        });
      }); // this.getMaparea(this.areaName)

      console.log('that.selectType', that.selectType);

      switch (that.selectType) {
        case 0:
          that.selectMarker();
          break;

        case 1:
          that.selectLine();
          break;

        case 2:
          that.drawLine();
          break;
      }
    },
    // 地图选取坐标点
    selectMarker: function selectMarker() {
      var _this4 = this;

      var markerClick = map.on('click', function (e) {
        if (_this4.selectedMarker) map.remove(_this4.selectedMarker);
        _this4.markerPosition = [e.lnglat.getLng(), e.lnglat.getLat()];

        _this4.$emit('labelPosition', [e.lnglat.getLng(), e.lnglat.getLat()]);
      });
    },
    // 地图画线功能
    selectLine: function selectLine() {
      var _this5 = this;

      console.log('enter', this.pipePositionLists);
      var outer = [];
      this.pipePositionLists.forEach(function (item, index) {
        item.forEach(function (item1, index1) {
          if (index1 == item.length - 1) {
            map.setCenter(new AMap.LngLat(item1[0], item1[1]));
            map.setZoom(15);
          }

          outer.push(new AMap.LngLat(item1[0], item1[1]));
        });
        var polyLine = new AMap.Polyline({
          map: map,
          path: outer,
          strokeWeight: 5,
          strokeColor: '#55aaff',
          showDir: true,
          dirColor: '#fff'
        });
        console.log('outer', outer);

        _this5.polyLineArr.push(polyLine);

        var polyEditor = new AMap.PolyEditor(map, polyLine);

        _this5.polyEditorArr.push(polyEditor);

        console.log(outer[0][0]);
        console.log(outer[0][outer.length - 1]);
        map.add(new AMap.Marker({
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
          position: outer[0]
        }));
        map.add(new AMap.Marker({
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
          position: outer[outer.length - 1]
        }));
        outer = [];
      });
      this.markerList.forEach(function (item) {
        var marker = new AMap.Marker({
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
          position: new AMap.LngLat(item[0], item[1])
        });
        map.add(marker);
      });
      console.log('pipeMarkerPositionList', this.pipeMarkerPositionList);
      this.pipeMarkerPositionList.forEach(function (item, index) {
        item.childArr.forEach(function (item1, index1) {
          var marker = new AMap.Marker({
            content: "<img src=\"".concat(mapImg, "\" style=\"width: 50px;height:50px\" />"),
            position: new AMap.LngLat(item1.coordinate.split(',')[0], item1.coordinate.split(',')[1])
          });
          map.add(marker);
          marker.on('click', function () {
            console.log('enter click', item1.imageId);
            _this5.title = item1.name;

            _this5.getPhotos(item1.imageId); // this.getPhotos(851)

          });
        });
      });
    },
    getPhotos: function getPhotos(id) {
      var _this6 = this;

      queryFileList(this.markerPhotoUrl, id).then(function (vo) {
        if (vo.success) {
          _this6.photoItems = [];
          vo.result.forEach(function (e) {
            _this6.photoItems.push(_this6.url.imgerver + e.id);
          });
          _this6.current = 0;
        }

        _this6.showMap = true;
      });
    },
    // 两点确定一条直线
    drawLine: function drawLine() {
      var _this7 = this;

      // 之前设过,现在修改
      if (this.labelPositions) {
        this.labelMarker = new AMap.Marker({
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
          position: new AMap.LngLat(this.labelPositions.split(',')[0], this.labelPositions.split(',')[1])
        });
        var outer = [new AMap.LngLat(this.markerPosition[0], this.markerPosition[1]), new AMap.LngLat(this.labelPositions.split(',')[0], this.labelPositions.split(',')[1])];
        this.outline = new AMap.Polyline({
          map: map,
          path: outer,
          borderWeight: 2,
          strokeColor: '#55aaff'
        });
        map.add(this.labelMarker);
      } // 该区域其他的站点的label标签坐标


      if (this.lastLabel.length > 0) {
        this.lastLabel.forEach(function (item, index) {
          new AMap.Marker({
            map: map,
            icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
            position: new AMap.LngLat(item.labelposi.split(',')[0], item.labelposi.split(',')[1])
          });
          new AMap.Marker({
            map: map,
            icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
            position: new AMap.LngLat(item.posi.split(',')[0], item.posi.split(',')[1])
          });
          var outer = [new AMap.LngLat(item.labelposi.split(',')[0], item.labelposi.split(',')[1]), new AMap.LngLat(item.posi.split(',')[0], item.posi.split(',')[1])];
          new AMap.Polyline({
            map: map,
            path: outer,
            borderWeight: 2,
            strokeColor: '#ff0000'
          });
        });
      }

      var markerClick = map.on('click', function (e) {
        if (_this7.labelMarker) map.remove(_this7.labelMarker);
        if (_this7.outline) map.remove(_this7.outline);
        _this7.labelMarker = new AMap.Marker({
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
          position: new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat())
        });
        var outer = [new AMap.LngLat(_this7.markerPosition[0], _this7.markerPosition[1], true), new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat(), true)];
        _this7.outline = new AMap.Polyline({
          map: map,
          path: outer,
          borderWeight: 2,
          strokeColor: '#55aaff'
        });

        _this7.$emit('labelPosition', [e.lnglat.getLng(), e.lnglat.getLat()]);

        map.add(_this7.labelMarker);
      });
    }
  }
};